/* Gedeeld accordeon-component (solza-accordion.liquid).
   Toggle via class + aria-expanded; inhoud blijft altijd in de DOM
   (verbergen gebeurt in CSS via grid-rows, animeerbaar en
   reduced-motion-vriendelijk). Meerdere items tegelijk open is
   toegestaan: er wordt bewust niets automatisch gesloten. */
(function () {
  /* Meerdere afnemers op 1 pagina laden dit script mogelijk 2x
     (PDP-specs + merk-FAQ); zonder guard zou elke klik dubbel
     toggelen en per saldo niets doen. */
  if (window.__solzaAccordionInit) return;
  window.__solzaAccordionInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.solza-acc__trigger');
    if (!btn) return;
    var item = btn.closest('[data-solza-acc]');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
